export default {
  CARD: 'card'
};


// WEBPACK FOOTER //
// ./src/components/language/itemTypes.js